import Swiper, { Navigation, Lazy } from "swiper";
import resize from "../resize";
Swiper.use([Navigation, Lazy]);

const initPartnersSlider = () => {
  const sliderContainerDesc = document.querySelector(".partners-slider-desc");
  const sliderContainerMob = document.querySelector(".partners-slider-mob");
  let swiper = null;

  if (sliderContainerDesc && sliderContainerMob) {
    function swiperDesc() {
      swiper = new Swiper(sliderContainerDesc, {
        loop: true,
        lazy: true,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: ".partners .slider-navigation__button--next",
          prevEl: ".partners .slider-navigation__button--prev",
        },
        pagination: {
          el: ".partners .partners-pagination",
          bulletActiveClass: "active",
          clickable: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: "Переход на предыдущий слайд",
          nextSlideMessage: "Переход на следующий слайд",
        },
      });
    }

    function swiperMob() {
      swiper = new Swiper(sliderContainerMob, {
        loop: true,
        lazy: true,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: ".partners .slider-navigation__button--next",
          prevEl: ".partners .slider-navigation__button--prev",
        },
        pagination: {
          el: ".partners .partners-pagination",
          bulletActiveClass: "active",
          clickable: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: "Переход на предыдущий слайд",
          nextSlideMessage: "Переход на следующий слайд",
        },
      });
    }

    function destroy() {
      if (swiper) {
        swiper.destroy();
        swiper = null;
      }
    }

    function resizeSwiper() {
      if (window.innerWidth <= 767) {
        destroy();
        swiperMob();
      } else {
        destroy();
        swiperDesc();
      }
    }

    resizeSwiper();
    resize(resizeSwiper);
  }
};

export default initPartnersSlider;
